import React, { useContext } from 'react';

import { Select } from 'antd';

import { ListContext } from '@contexts/ListContext';

const Option = Select.Option;

const FamilySelector = ({ onChange, value, disabled, onBlur, subject }) => {
    const { cachedList } = useContext(ListContext);
    let families = [...cachedList.transactionFamilies.items];

    if (subject) {
        switch (subject) {
            case 'model':
                families = families.filter(
                    (el) =>
                        !['AgFee', 'CommAsMothAg', 'JobCredit', 'Product', 'MothAgComm', 'MothAgCommAdj'].includes(
                            el.Code
                        )
                );
                break;
            case 'agency':
                families = families.filter((el) => !['Refund', 'JobRefund', 'Product', 'AgFee'].includes(el.Code));
                break;
            case 'client':
                families = families.filter(
                    (el) => !['CommAsMothAg', 'MothAgComm', 'MothAgCommAdj', 'Refund'].includes(el.Code)
                );
                break;
            default:
                break;
        }
    }

    return (
        <Select
            autoComplete="off"
            mode="multiple"
            value={value}
            placeholder="Please select"
            onChange={onChange}
            onBlur={onBlur}
            disabled={disabled}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
        >
            {families.map((el) => (
                <Option key={el.Code} value={el.Code}>
                    {el.Name}
                </Option>
            ))}
        </Select>
    );
};

export default FamilySelector;
